import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Wrapper } from "../../Wrapper";
import { Image } from "@learningblocks/shared-components/lib/Image";
import CloseLid from "@common/images/mc_closelid_icon.svg";
import OpenLid from "@common/images/mc_openlid_icon.svg";
import RemoveRotor from "@common/images/mc_remove_rotor_icon.svg";
import RemoveTube from "@common/images/mc_remove_tube_icon.svg";
import Settings from "@common/images/mc_settings_icon.svg";
// import Glossary from '@common/images/mc_glossary.svg';
import { MCStateContext } from "../..";
import { TABS } from "../../ModalWindow/ModalWindow.utils";

import "./style.scss";
/**
 * TooltipHover:
 *    to render tooltip when centrifuge state is hover
 */
export function TooltipHover(props) {
  const { t } = useTranslation();
  const { isLidOpen } = React.useContext(MCStateContext);

  const className =
    isLidOpen && (props.solutionPresent || props.rotorPresent)
      ? `mc_tooltip_hover--evenItems`
      : `mc_tooltip_hover--oddItems`;

  const renderOpenLid = () =>
    !isLidOpen && (
      <Image
        src={OpenLid}
        alt={t("OpenLid.string")}
        onClick={props.toggleLid}
      />
    );
  const renderCloseLid = () =>
    isLidOpen && (
      <Image
        src={CloseLid}
        alt={t("CloseLid.string")}
        onClick={props.toggleLid}
      />
    );

  const renderSettings = () => {
    const onClick = () => {
      props.setModalView(TABS.TOP_VIEW);
      props.openModal();
    };
    return (
      <Image
        src={Settings}
        alt={t("MicrocentrifugeSettings.string")}
        onClick={onClick}
      />
    );
  };

  const renderRemoveSolution = () => {
    const onClick = () => {
      props.removeSlotItems("solution");
    };
    return (
      isLidOpen &&
      props.solutionPresent && (
        <Image
          src={RemoveTube}
          alt={t("RemoveSolutionTubes.string")}
          onClick={onClick}
        />
      )
    );
  };

  const renderRemoveRotor = () => {
    const onClick = () => {
      props.removeSlotItems("rotor");
    };
    return (
      isLidOpen &&
      !props.solutionPresent &&
      props.rotorPresent && (
        <Image
          src={RemoveRotor}
          alt={t("RemoveRotorAdapters.string")}
          onClick={onClick}
        />
      )
    );
  };

  // No sims currently use the glossary button. There's no on click function on the image.
  // const renderGlossary = () => {
  //   return <Image  src={Glossary} alt={t('OpenGlossary.string')} />;
  // };

  const onMouseLeave = () => props.setHover(false);
  const onMouseEnter = () => props.setHover(true);

  return (
    <Wrapper
      className={`${className} ${props.className}`}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
    >
      {/* {renderGlossary()} */}
      {renderOpenLid()}
      {renderCloseLid()}
      {renderRemoveSolution()}
      {renderRemoveRotor()}
      {renderSettings()}
    </Wrapper>
  );
}

TooltipHover.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * callback function to set hover state
   */
  setHover: PropTypes.func,
  /**
   * specifies if there are solution(tubes) in centrifuge
   */
  solutionPresent: PropTypes.bool,
  /**
   * specifies if there are rotors in centrifuge
   */
  rotorPresent: PropTypes.bool,
  /**
   * callback function to toggle microcentrifuge lid open and close
   */
  toggleLid: PropTypes.func,
  /**
   * callback function to set modal view tab (accepts values FRONT_VIEW or TOP_VIEW)
   */
  setModalView: PropTypes.func,
  /**
   * callback function to open modal window
   */
  openModal: PropTypes.func,
  /**
   * callback function to remove all items from slot' item can be solution(tube) or rotor
   */
  removeSlotItems: PropTypes.func,
};
